import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import style from './style.module.css'

export const MainContent = () => {
  const { t } = useTranslation()

  return (
    <div className={clsx(style.wrapper)}>
      {/* ヘッダー: ログインユーザーの取得を実行しないようにしたいので共通ヘッダーは使っていない */}
      <div className={clsx(style.header)}>
        <img
          className={clsx(style.logoImage)}
          alt={t('maintenance.altairLogo')}
          src="/altair.svg"
        />
      </div>

      <div className={clsx(style.main)}>
        <div className={clsx(style.contents)}>
          <p>いつもAltairをご利用いただきありがとうございます。</p>
          <p>
            システムメンテナンスのため、下記日程にてサービスの停止をおこないます。
          </p>
          <p>
            停止期間中は、Altairをご利用いただくことができません。
            <br />
            お急ぎのご注文につきましては、余裕を持ったご注文をお願いいたします。
          </p>
          <p className={clsx(style.schedule)}>
            <strong>■システム停止期間</strong>
            <br />
            2026年2月18日（水）22:00 ～ 2月19日（木）6:00頃
            <br />
            <span className={clsx(style.note)}>
              ※終了時刻は前後する場合がございます。
            </span>
          </p>
          <p>
            皆様には大変ご不便をおかけしますことお詫び申し上げますとともに、何卒ご理解を賜りますよう、よろしくお願い申し上げます。
          </p>
        </div>
        <div className={clsx(style.illust)}></div>
      </div>
    </div>
  )
}
